import { PhasePlaceholder } from '../components/PhasePlaceholder.js';

export function BudgetPage() {
  return (
    <PhasePlaceholder
      title="Budget"
      phase={5}
      criteria={[
        'Kategóriánkénti havi limit, felhasználás kijelzése.',
        'Jelzés 80% és 100% felett.',
        'Költhető / Vésztartalék / Hosszú távú összegek automatikus számolása.',
      ]}
    />
  );
}
